// import { UserPermissionService } from '../../../services/user-permission-service';
import { fetchReturnRabbitAddOn } from '../../../pages/settings/api/add-ons-api';
import { manageSubscription, getPlanInfo } from '../../../pages/settings/api/subscription';
import { isNewLineupPlanPorfileAndBillingPlan } from '../../../feature-gates/feature-gate-helper';

export const getDataForUsersWithAccountManagementRole = (data) => {
  // oxlint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    // todo return this when we're not in a rush.
    // const { roles } = data.input.currentUser;
    // const isAccountManager = UserPermissionService.userHasAccountManagementRole(roles);
    // const isSystemAdministrator = UserPermissionService.userIsSystemAdministrator(roles);
    // if (!isAccountManager && !isSystemAdministrator) {
    //   resolve({
    //     planInfo: {},
    //     subscriptionData: {},
    //   });
    //   return;
    // }

    try {
      const promises = [getPlanInfo(true), manageSubscription()];

      const promiseData = await Promise.all(promises);
      const errors = promiseData.filter((response) => response?.status && response.status !== 200).map((response) => response.statusText);
      if (errors.length > 0) {
        throw new Error(errors.join(','));
      }
      const [planInfoResponse, manageSubscriptionResponse] = promiseData;
      const subscriptionData = manageSubscriptionResponse.data || {};
      const newData = {
        planInfo: planInfoResponse.data || {},
        subscriptionData,
      };

      // The Return Rabbit add-on is injected through the FE code instead of being treated the same as
      // other add-ons coming from the BE. This feature is no longer available as an add-on for new, feature gated plans,
      // so don't fetch it for those plans.
      const sellerPlanProfileId = data.input.seller?.subscriptionPlanInfo?.planProfileId;
      const sellerBillingPlanId = data.input.seller?.subscriptionPlanInfo?.billingPlanId;
      if (sellerPlanProfileId && sellerBillingPlanId && !isNewLineupPlanPorfileAndBillingPlan(sellerPlanProfileId, sellerBillingPlanId)) {
        // Don't error the app on this failing. Should have catch built in
        // Don't await on this to avoid blocking app load on external dep
        fetchReturnRabbitAddOn();
      }

      resolve(newData);
    } catch (e) {
      reject(e);
    }
  });
};
